import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { FAQS_PERFORMANCE } from "@/lib/service-content/faqs/performance";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { validateAuditReturnSearch } from "@/lib/audit-return-search";

const PATH = "/es/rendimiento";

export const Route = createFileRoute("/es/rendimiento")({
  validateSearch: validateAuditReturnSearch,
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Optimización de Velocidad Shopify en México | Core Web Vitals · Shugert",
    description: "Optimización de rendimiento Shopify para México: LCP, INP y CLS con datos de campo, diagnóstico de causa raíz, implementación en staging y validación comparable.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-performance-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Velocidad Shopify en México", path: PATH }]),
      faqJsonLd(FAQS_PERFORMANCE.es),
      serviceJsonLd({
        name: "Optimización de Velocidad Shopify en México",
        description: "Servicio de rendimiento y Core Web Vitals para tiendas Shopify y Shopify Plus en México y Latinoamérica: LCP, INP, CLS, apps, JavaScript y entrega del storefront.",
        path: PATH,
        serviceType: "Optimización de Rendimiento Shopify",
        minPrice: 2500,
        maxPrice: 4000,
        unit: "PROJECT",
        deliverables: ["Línea base comparable", "Mapa de causa raíz", "Implementación en staging", "Validación antes y después", "Plan de regresión"],
        locale: "es",
      }),
      webPageJsonLd({ name: "Optimización de Velocidad Shopify en México", path: PATH, description: "Ingeniería Shopify basada en datos de campo para mejorar LCP, INP y CLS con staging y validación comparable.", inLanguage: "es-MX" }),
    ],
  }),
});
